import { Icon } from '@iconify/react';
import React, { useState } from 'react';
import {
    ChainSelector,
    InfoCard,
    InfoCardList,
    PageWrapper,
    ReceiptDrawer,
} from 'components';
import { pageStyles, ReceiptRoot } from 'lib';
import {
    CardDataItem,
    infoCardListStyles,
} from '../../components/info-card-list/info-card-list-helper';
import { useAuth } from '../../core';
import { ROLES } from '../../core/contexts/permissions';
import { ReceiptList } from './components/ReceiptList';
import { cardDataReceipts } from 'constants/neo-card-data';
import { Box, Button, Grid } from '@mui/material';

export const Receipts = (): React.JSX.Element => {
    const { getRoles } = useAuth();
    const isAdminRole: boolean = getRoles().includes(ROLES.admin);
    const [selectedChain, setSelectedChain] = useState<string>('');
    const [selectedReceipt, setSelectedReceipt] = useState<ReceiptRoot>();

    return (
        <PageWrapper title='Receipts'>
            <Grid item xs={12} md={8} sx={pageStyles.infoCardGrid}>
                <InfoCardList>
                    {cardDataReceipts.map((card: CardDataItem) => (
                        <InfoCard
                            key={card?.title}
                            title={card?.title}
                            description={card.description}
                            action={
                                <Button
                                    color='inherit'
                                    size='medium'
                                    style={infoCardListStyles.infoCardButton}
                                    startIcon={
                                        <Icon
                                            icon={
                                                card?.cta?.icon
                                                    ? card?.cta?.icon
                                                    : ''
                                            }
                                            style={
                                                infoCardListStyles.infoCardIcon
                                            }
                                        />
                                    }
                                >
                                    {card?.cta?.text}
                                </Button>
                            }
                        />
                    ))}
                </InfoCardList>
            </Grid>
            <Box sx={{ mt: 2 }}>
                <ChainSelector
                    selectedChain={selectedChain}
                    setSelectedChain={setSelectedChain}
                    text='Select a chain to see your receipts.'
                />
                {selectedChain ? (
                    <ReceiptList
                        selectedChain={selectedChain}
                        setSelectedReceipt={setSelectedReceipt}
                        contractType='smartcontracts'
                        receiptType={isAdminRole ? 'admin' : 'user'}
                    />
                ) : null}
            </Box>
            <ReceiptDrawer
                selectedReceipt={selectedReceipt}
                setSelectedReceipt={setSelectedReceipt}
            />
        </PageWrapper>
    );
};
